import MaintenancePage from "../../components/feature/MaintenancePage";
import SEOHead from "../../components/feature/SEOHead";

const LOGO =
  "https://storage.readdy-site.link/project_files/9ee712e0-c50a-4d2b-9956-d4b4346de3f4/7412105e-ed20-425a-a250-0da2f7ef7969_S99_Logo.png?v=e9bb3c1ef0851b808f8058aed7191c08";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "https://example.com";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/s99au#website`,
  name: "S99AU",
  url: `${siteUrl}/s99au`,
  inLanguage: "en-AU",
  description:
    "S99AU is currently undergoing scheduled maintenance. We'll be back shortly with an improved online gaming experience.",
};

export default function S99AU() {
  return (
    <>
      <SEOHead
        title="S99AU | We'll Be Back Shortly — Maintenance Mode"
        description="S99AU is currently undergoing scheduled maintenance. We're working hard to improve your experience. Check back soon!"
        keywords="S99AU, S99, online gaming, maintenance"
        canonicalPath="/s99au"
        schemaJson={schema}
        ogImage={LOGO}
        ogImageAlt="S99AU Logo"
        siteName="S99AU"
      />
      <MaintenancePage
        logoSrc={LOGO}
        logoAlt="S99 Logo"
        accentColor="#C9A227"
        glowRgb="201,162,39"
        bgFrom="#1a1400"
        whatsappLink="https://wa.me/61451485303"
        telegramLink="https://t.me/S99AUCS001"
      />
    </>
  );
}
